import type { RangeKey } from '@dataTypes/dashboard.types'
import {
  getClinicGoal,
  type ClinicGoal,
} from '@services/api/dashboard/clinic-goal.api'
import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
} from './useDashboardPeriod'

type UseClinicGoalOptions = {
  range: RangeKey
  date: string
  enabled?: boolean
  queued?: boolean
}

export type UseClinicGoalResult = {
  loading: boolean
  error: string | null
  goal: ClinicGoal | null
}

export function useClinicGoal({
  range,
  date,
  enabled = true,
  queued = false,
}: UseClinicGoalOptions): UseClinicGoalResult {
  const params = useDashboardPeriodParams(range, date)
  const { data, loading, error } = useDashboardPeriodFetch(
    params,
    getClinicGoal,
    { enabled, queued, cacheKey: 'getClinicGoal' },
  )

  return {
    loading,
    error,
    goal: data,
  }
}
